import { apiClient } from './client'

export interface SavedPrompt {
  /** Integer legacy id, or definition UUID string once the Prompt Library serves the route. */
  id: number | string
  projectId: number
  title: string
  body: string
  tags: string[]
  createdBy: number
  usageCount: number
  lastUsedAt: string | null
  createdAt: string
  updatedAt: string
}

export interface PromptUploadResult {
  prompt: SavedPrompt
  created: boolean
}

export const promptsApi = {
  list: (projectId: number) => apiClient.get<SavedPrompt[]>(`/projects/${projectId}/prompts`),
  /**
   * Upload a Markdown file into the project's prompt library. Optional YAML
   * frontmatter (`title`, `tags`) is parsed off the top server-side; title
   * falls back to the filename. Upserts by title.
   */
  uploadMarkdown: (projectId: number, file: File) =>
    apiClient.upload<PromptUploadResult>(`/projects/${projectId}/prompts/upload`, file),
}
